export const liveMarkets = [
    {
      id: 1,
      question: "Will Bitcoin hit $200,000 before January 2027?",
      timeLeft: "326d 14h",
      participants: 312,
      averageGuess: 42,
      prize: "🏅 Prophet Badge",
      difficulty: "Medium",
      category: "Crypto",
      yourLastGuess: null,
      inspiration: "Kahneman's anchoring effect suggests the current price heavily biases our predictions — traders anchored to recent highs consistently overestimate future peaks."
    },
    {
      id: 2,
      question: "Will an AI model pass a bar exam with a top 1% score by end of 2026?",
      timeLeft: "296d 10h",
      participants: 287,
      averageGuess: 61,
      prize: "🤖 AI Oracle Badge",
      difficulty: "Hard",
      category: "Technology",
      yourLastGuess: null,
      inspiration: "Kahneman warned about the planning fallacy — we systematically underestimate how long breakthroughs take, yet overestimate how transformative they'll be once they arrive."
    },
    {
      id: 3,
      question: "Will SpaceX land humans on Mars by end of 2028?",
      timeLeft: "1056d 6h",
      participants: 408,
      averageGuess: 12,
      prize: "🚀 Mars Pioneer Badge",
      difficulty: "Hard",
      category: "Science",
      yourLastGuess: null,
      inspiration: "Base rate neglect is powerful here — Tversky & Kahneman showed we ignore historical timelines of similar megaprojects and instead anchor to the optimistic forecasts of charismatic leaders."
    },
    {
      id: 4,
      question: "Will the US officially enter a recession in 2026?",
      timeLeft: "296d 10h",
      participants: 345,
      averageGuess: 35,
      prize: "📉 Macro Sage Badge",
      difficulty: "Medium",
      category: "Finance",
      yourLastGuess: null,
      inspiration: "The availability heuristic (Tversky & Kahneman, 1973) means recent headlines about layoffs or bank stress make a recession feel more likely than base rates suggest."
    },
    {
      id: 5,
      question: "Will Tesla stock hit $500 before July 2026?",
      timeLeft: "141d 3h",
      participants: 276,
      averageGuess: 47,
      prize: "📈 Stock Whisperer Badge",
      difficulty: "Medium",
      category: "Finance",
      yourLastGuess: null,
      inspiration: "Thaler's overreaction hypothesis shows investors swing wildly on narrative — ask yourself whether your estimate is driven by fundamentals or by the latest Elon headline."
    },
    {
      id: 6,
      question: "Will Apple release AR glasses in 2026?",
      timeLeft: "296d 10h",
      participants: 198,
      averageGuess: 29,
      prize: "👓 Tech Visionary Badge",
      difficulty: "Medium",
      category: "Technology",
      yourLastGuess: null,
      inspiration: "Confirmation bias (Nickerson, 1998) leads Apple fans to overweight rumors that confirm a launch, while skeptics dismiss the same evidence — Annie Duke calls this 'resulting.'"
    },
    {
      id: 7,
      question: "Will any country ban TikTok in 2026?",
      timeLeft: "296d 10h",
      participants: 421,
      averageGuess: 64,
      prize: "🌍 Geopolitics Guru Badge",
      difficulty: "Easy",
      category: "Politics",
      yourLastGuess: null,
      inspiration: "The representativeness heuristic (Kahneman & Tversky) makes us judge likelihood by how well a story fits a narrative — 'government bans popular app' feels familiar, but how often does it actually happen?"
    },
    {
      id: 8,
      question: "Will a self-driving taxi service operate in 5+ US cities by end of 2026?",
      timeLeft: "296d 10h",
      participants: 189,
      averageGuess: 53,
      prize: "🚗 Autonomy Ace Badge",
      difficulty: "Medium",
      category: "Technology",
      yourLastGuess: null,
      inspiration: "Ariely's research on the 'IKEA effect' applies to tech forecasting — companies that have invested years in autonomous driving overvalue their own progress, and so do their fans."
    },
    {
      id: 9,
      question: "Will the next Super Bowl (Feb 2027) break viewership records?",
      timeLeft: "365d 0h",
      participants: 157,
      averageGuess: 72,
      prize: "🏈 Sports Analyst Badge",
      difficulty: "Easy",
      category: "Sports",
      yourLastGuess: null,
      inspiration: "Herd mentality is strong in sports predictions — Thaler's research on the winner's curse shows crowds consistently overvalue recent trends and extrapolate them into the future."
    },
    {
      id: 10,
      question: "Will a new COVID variant cause widespread school closures in 2026?",
      timeLeft: "296d 10h",
      participants: 263,
      averageGuess: 14,
      prize: "🔬 Pandemic Forecaster Badge",
      difficulty: "Hard",
      category: "Science",
      yourLastGuess: null,
      inspiration: "The affect heuristic (Slovic) means our emotional memory of 2020 lockdowns distorts probability estimates — Annie Duke reminds us to separate the vividness of past experience from actual likelihood."
    }
  ]
